import { render, staticRenderFns } from "./ReportStatistico.vue?vue&type=template&id=f58bccde"
import script from "./ReportStatistico.vue?vue&type=script&lang=js"
export * from "./ReportStatistico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports